import { Link } from "react-router-dom";
import { Mic2, CalendarCheck, Headphones } from "lucide-react";

export const ACTIONS = [
  ["/booking", "Book 00shot", CalendarCheck],
  ["/feature", "Feature request", Mic2],
  ["/studio", "Studio session", Headphones],
];

export const ActionButtons = ({ prefix, className = "" }) => (
  <div className={`grid grid-cols-1 sm:grid-cols-3 gap-3 ${className}`}>
    {ACTIONS.map(([to, label, Icon]) => (
      <Link key={to} to={to} data-testid={`${prefix}-${to.slice(1)}-button`}
        className="btn-line rounded-full px-6 py-3.5 font-cond uppercase font-bold tracking-widest text-base inline-flex items-center justify-center gap-2 text-slate-100">
        <Icon className="w-4 h-4 text-lime" /> {label}
      </Link>
    ))}
  </div>
);
